import {combineReducers} from 'redux'

import navBarChangeReducer from './NavDrawerItemChangeReducer'

import SwapItemInMainLayoutReducer from './SwapItemInMainLayoutReducer'

export default combineReducers ({navBarChangeReducer, SwapItemInMainLayoutReducer})